module.exports = __webpack_public_path__ + "img/case-logo-15.9bbbde5e.png";